import { render, staticRenderFns } from "./SurfaceTitleMobile.vue?vue&type=template&id=4c8c8da6&scoped=true&"
import script from "./SurfaceTitleMobile.vue?vue&type=script&lang=ts&"
export * from "./SurfaceTitleMobile.vue?vue&type=script&lang=ts&"
import style0 from "./SurfaceTitleMobile.vue?vue&type=style&index=0&id=4c8c8da6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8c8da6",
  null
  
)

export default component.exports